import LambdaLib from "@jurinfor/game-process/lambda";
import traceReduction from "./framework/lambda-plugin/traceReduction";
import { standardReductionRule } from "./scenario/mainReduction";

const { config, importFromJSON, exportToJSON, reduceLambdaObject, reduce } = LambdaLib;
const { isLambdaJSON, StringToLambdaJSON, LambdaJSONToString } = LambdaLib.json;

window.debug = {};

window.debug.traceStandardReduction = function traceStandardReduction(term) {
  traceReduction(term, { fixpoint: "standardReduction", equal: standardReductionRule });
};
window.debug.traceReduction = traceReduction;

window.LambdaJSONToString = LambdaJSONToString;
window.exportToJSON = exportToJSON;
window.reduceLambdaObject = reduceLambdaObject;
window.reduce = reduce;
window.debug.evp = (p, max = 100) => {
  const t = importFromJSON({
    type: "LambdaExternal",
    objType: "Process",
    object: { type: "Pass" },
  });
  t.object = p;
  const standardReductionSpec = {
    fixpoint: "standardReduction",
    equal: {
      alt: [
        'Delay', // higher precedence!
        { seq: ['MultivariateFunctionCompile', 'never'] },
        { mu: 'standardReduction' },
        { nu: 'standardReduction' },
        { LetRecLocal: 'standardReduction' },
        { Literal: 'standardReduction', reduceObjTypes: ['Object'], inlineObjTypes: ['Object', 'Number', 'String', 'LambdaJSON', 'Table'] },
        { Literal: 'standardReduction', reduceObjTypes: ['Process'], inlineObjTypes: ['Object', 'Number', 'String', 'Process', 'LambdaJSON'] },
        { Literal: 'standardReduction', reduceObjTypes: ['LambdaJSON'], inlineObjTypes: ['Object', 'Number', 'String', 'LambdaJSON'] },
        'CaseBool',
        'Concat',
        'Quote',
        'Unquote',
        'Delay',
        'EvalDelay',
        'RemoveNulls',
        'Filter',
        'CrossJoin',
        'JoinOn',
        // 'RunDiagram',
        'TableTransformation',
        'inline-external-process',
        { epsilon: 'standardReduction', objType: 'ArrayList' },
        { 'ArrayListCollapse': 'never', objType: 'Object' },
        { 'ArrayListCollapse': 'never', objType: 'Number' },
        { 'ArrayListCollapse': 'never', objType: 'Boolean' },
        { 'ArrayListCollapse': 'never', objType: 'String' },
        'FixedPoint',
        'MultivariateFunction-C',
        'Function',
        'beta-eager-on-static-objType',
        'letrec-simplify',
        'letrec-empty',
        'letrec-expand-eager-on-static-objType',
        'letrec-substitute-eager-on-static-objType',
      ],
    },
  };

  const r = {
    max: max,
    tau: {
      label: "iteration step",
      threshold: 0,
      log: {
        alt: [
          "ProcessReduction",
          "inline-external-process",
          {
            objType: "Process",
            External: {
              fixpoint: "r",
              equal: {
                alt: [
                  standardReductionSpec,
                  { 'eager-once': () => "ProcessReduction" },
                  { 'eager-once': () => "inline-external-process" },
                  { 'eager-once': () => ({ seq: ['letrec-expand-eager-on-static-objType', { opt: 'letrec-simplify' }] }) },
                  { 'eager-once': () => ({ seq: [{ External: { xi: { label: "proc dep", log: { tau: "r", max: 1 } } }, objType: "Process" }, "id"] }) },
                ],
              },
            },
          },
          // { 'eager-once': () => "RunDiagram" },
          { 'eager-once': () => ({ seq: ['letrec-substitute-koca', { opt: 'letrec-simplify' }, { opt: standardReductionSpec }] }) },
        ],
      },
    },
  };
  return reduce(t, r);
}
